import {Component} from "../interface/component";
require('slick-carousel/slick/slick.min');

export class BannerCarouselComponent implements Component {

    private $root:JQuery;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
    }

    init() {
        this.bindUI();
    }

    /**
     * Slick Settings
     */
    private bindUI() {
        let dots = true;
        if (this.$root.children().length <= 1){
            dots = false;
        }
        this.$root.slick({
          dots: dots,
          infinite: true,
          speed: 500,
          fade: true,
          cssEase: 'linear'
        });
    }
}
